import { useRefetchQuery } from 'src/common/useRefetchQuery';
import { rSimProductsQueries } from '../utils/rsimProductsQueries';
import { useEffect } from 'react';
import { useRSimQuery } from 'rSimInventory/hooks/useRSimQuery.ts';

export const useRSimProducts = () => {
  const refetchSimInventory = useRefetchQuery(rSimProductsQueries.allSims());

  const { queryResult, queryKey } = useRSimQuery();

  useEffect(() => {
    refetchSimInventory();
  }, [queryResult.data.data]);

  return {
    queryResult,
    queryKey,
  };
};
